export default "__VITE_ASSET__kLo2OJ7W__"